import React from 'react';
import { Icon24UtilityCheckmark } from '@care/react-icons';
import { Container, Grid, List, ListItem, Typography, Box, type Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

export enum CaregiverVerificationsAttributes {
  PHONE_NUMBER_VERIFIED = 'PHONE_NUMBER_VERIFIED',
  EMAIL_ID_VERIFIED = 'EMAIL_ID_VERIFIED',
  FACEBOOK_USER_LINKED = 'FACEBOOK_USER_LINKED',
}
const caregiverVerificationsLabels: {
  [key in CaregiverVerificationsAttributes]: string;
} = {
  [CaregiverVerificationsAttributes.PHONE_NUMBER_VERIFIED]: 'Phone verified',
  [CaregiverVerificationsAttributes.EMAIL_ID_VERIFIED]: 'Email verified',
  [CaregiverVerificationsAttributes.FACEBOOK_USER_LINKED]: 'Facebook verified',
};

/* Using this component for highlights and verification is causing issues. For now relaxed the type check. Need to re-visit. */
const Verifications = ({
  features,
  title,
}: {
  features: CaregiverVerificationsAttributes[];
  title: String;
}) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <Container maxWidth="md" sx={{ pt: 1 }}>
      <Typography variant={isMobileOrSmaller ? 'h2' : 'h1'}>{title}</Typography>
      <Box mt={2}>
        <List>
          <Grid container>
            {(features as Array<CaregiverVerificationsAttributes>).map(
              (feature): React.ReactElement => (
                <Grid item xs={12} lg={12} key={feature}>
                  <ListItem
                    sx={{
                      display: 'flex',
                      padding: '6px 0',
                      lineHeight: '26px',
                    }}>
                    <>
                      <Icon24UtilityCheckmark size={19} color="#027854" />
                      <Typography variant="body2" pl={2} fontWeight="bold">
                        {caregiverVerificationsLabels[feature as CaregiverVerificationsAttributes]}
                      </Typography>
                    </>
                  </ListItem>
                </Grid>
              )
            )}
          </Grid>
        </List>
      </Box>
    </Container>
  );
};

export default Verifications;
